module.exports = __webpack_public_path__ + "img/pajak_barang.578f0f2b.svg";